import React, { useState, useEffect } from 'react';
import api from '../BaseURL/BaseURL';
import { useAuth } from '../Contexts/AuthContext';
import deleteIcon from '../../assets/Images/delete.png';
import editIcon from '../../assets/Images/edit.png';

const Table = ({ items: initialItems }) => {
  const [items, setItems] = useState(() => {
    return JSON.parse(localStorage.getItem('items')) || [];
  });  
  const [mealTypes, setMealTypes] = useState([]);
  const [foodTypes, setFoodTypes] = useState([]);
  const [sources, setSources] = useState([]);
  const [reasons, setReasons] = useState([]);
  const [editingIndex, setEditingIndex] = useState(null);
  const [deleteIndex, setDeleteIndex] = useState(null);
  const [editItem, setEditItem] = useState({}); // State for the item being edited
  const { token } = useAuth();
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);


  useEffect(() => {
    const fetchMealTypes = async () => {
      try {
        const response = await api.get('/employee/meal-types', {
          headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${token}`,
          },
        });
        if (response.status === 200 && response.data.status) {
          setMealTypes(response.data.data);
        }
      } catch (error) {
        console.error('Error fetching meal types:', error);
      }
    };

    fetchMealTypes();
  }, [token]);

  useEffect(() => {
    const fetchFoodTypes = async () => {
      try {
        const response = await api.get('/employee/food-types', {
          headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${token}`,
          },
        });
        if (response.status === 200 && response.data.status) {
          setFoodTypes(response.data.data);
        }
      } catch (error) {
        console.error('Error fetching food types:', error);
      }
    };

    fetchFoodTypes();
  }, [token]);

  useEffect(() => {
    const fetchSources = async () => {
      try {
        const response = await api.get('/employee/sources', {
          headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${token}`,
          },
        });
        if (response.status === 200 && response.data.status) {
          setSources(response.data.data);
        }
      } catch (error) {
        console.error('Error fetching sources:', error);
      }
    };

    fetchSources();
  }, [token]);

  useEffect(() => {
    const fetchReasons = async () => {
      try {
        const response = await api.get('/employee/reasons', {
          headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${token}`,
          },
        });
        if (response.status === 200 && response.data.status) {
          setReasons(response.data.data);
        }
      } catch (error) {
        console.error('Error fetching reasons:', error);
      }
    };

    fetchReasons();
  }, [token]);
  
  const startEditing = (index) => {
    setEditingIndex(index);
    setEditItem(items[index]); // Set the current item for editing
  };

  const saveEdit = () => {
    const updatedItems = items.map((item, index) =>
      index === editingIndex ? { ...editItem, is_edible: editItem.is_edible } : item
    );
  
    setItems(updatedItems); 
    localStorage.setItem('items', JSON.stringify(updatedItems));
    setEditingIndex(null);
    setEditItem({});
  };
  
  

  const cancelEdit = () => {
    setEditingIndex(null);
    setEditItem({}); // Reset editing state
  };

  const confirmDelete = (index) => {
    setDeleteIndex(index); // Show confirmation popup
  };

  const deleteItem = () => {
    const updatedItems = items.filter((_, index) => index !== deleteIndex);
    setItems(updatedItems);
  
    // Update localStorage after deleting
    localStorage.setItem('items', JSON.stringify(updatedItems));
  
    setDeleteIndex(null);
  };
  
  const onSave = async () => {
    const storedItems = JSON.parse(localStorage.getItem('items')) || [];
    if (storedItems.length === 0) {
      alert('❌ لا يوجد عناصر لحفظها!');
      return;
    }
  
    // 🛠 Format the data correctly before sending
    const formattedData = {
      wastes: storedItems.map((item) => ({
        meal_type_id: item.meal_type_id || null,
        food_type_id: item.food_type_id || null,
        food_description_id: item.food_description_id || null,
        source_id: item.source_id || null,
        reason_id: item.reason_id || null,
        is_edible: item.is_edible,
        empty_weight: item.empty_weight !== "" ? parseFloat(item.empty_weight) : null,
        // empty_weight: item.empty_weight ? parseFloat(item.empty_weight) : null,
        total_weight: item.total_weight !== "" ? parseFloat(item.total_weight) : null,
        // total_weight: item.total_weight ? parseFloat(item.total_weight) : null,
        employee_name: item.employee_name || '',
        shift: item.shift || '',
        waste_date: item.waste_date || '',
      })),
    };
  
    console.log("🚀 Sending Data:", formattedData);
  
    let missingMessages = [];
    formattedData.wastes.forEach((waste, index) => {
      const entryNumber = `العنصر رقم ${index + 1}`;
      if (waste.meal_type_id === null)
        missingMessages.push(`${entryNumber}: نوع الوجبة`);
      if (waste.food_type_id === null)
        missingMessages.push(`${entryNumber}: نوع الغذاء`);
      if (waste.food_description_id === null)
        missingMessages.push(`${entryNumber}: وصف الغذاء`);
      if (waste.source_id === null)
        missingMessages.push(`${entryNumber}: المصدر`);
      if (waste.reason_id === null)
        missingMessages.push(`${entryNumber}: السبب`);
      if (waste.is_edible === null)
        missingMessages.push(`${entryNumber}: صالح/غير صالح`);
      if (waste.empty_weight === null)
        missingMessages.push(`${entryNumber}: الوزن الفارغ`);
      if (waste.total_weight === null)
        missingMessages.push(`${entryNumber}: إجمالي الوزن`);
      if (!waste.employee_name)
        missingMessages.push(`${entryNumber}: اسم الموظف`);
      if (!waste.shift)
        missingMessages.push(`${entryNumber}: الوردية`);
      if (!waste.waste_date)
        missingMessages.push(`${entryNumber}: التاريخ`);
    });
  
    if (missingMessages.length > 0) {
      const message =
        "❌ يرجى التحقق من صحة البيانات المدخلة:\n" +
        missingMessages.join("\n");
      alert(message);
      console.log("⚠️ Missing or invalid data detected:", missingMessages);
      return;
    }
  
    console.log("🚀 Sending Data:", formattedData);
  
    try {
      const response = await api.post('/employee/waste-data', formattedData, {
        headers: {
          Accept: 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });
  
      if (response.status === 200 && response.data.status) {
        setShowSuccessPopup(true);
        localStorage.removeItem('items'); // Clear saved data after success
        setItems([]); // Clear UI table
      } else {
        alert('❌ فشل في حفظ البيانات. حاول مرة أخرى.');
      }
    } catch (error) {
      console.error('❌ Error saving waste data:', error);
      alert('❌ حدث خطأ أثناء حفظ البيانات.');
    }
  };
  
  

  return (
    <div className="p-6" dir="rtl">
      <h1 className="text-2xl font-semibold text-right text-gray-700 mb-4">العناصر المضافة</h1>
      {items.length === 0 ? (
        <p className="text-gray-600 text-right">لا توجد بيانات.</p>
      ) : (
        <div className="overflow-x-auto max-h-80 overflow-y-auto border rounded-lg">
          <table className="w-full border-collapse border border-gray-300 text-sm md:text-base">
            <thead>
              <tr className="bg-gray-100">
                <th className="border border-gray-300 px-4 py-2 text-right">نوع الوجبة</th>
                <th className="border border-gray-300 px-4 py-2 text-right">المصدر</th>
                <th className="border border-gray-300 px-4 py-2 text-right">السبب</th>
                <th className="border border-gray-300 px-4 py-2 text-right">نوع الغذاء</th>
                <th className="border border-gray-300 px-4 py-2 text-right">وصف الغذاء</th>
                <th className="border border-gray-300 px-4 py-2 text-right">صالح/غير صالح</th>
                <th className="border border-gray-300 px-4 py-2 text-right">الوزن الفارغ</th>
                <th className="border border-gray-300 px-4 py-2 text-right">اجمالي الوزن</th>
                <th className="border border-gray-300 px-4 py-2 text-right">اسم الموظف</th>
                <th className="border border-gray-300 px-4 py-2 text-right">الوردية</th>
                <th className="border border-gray-300 px-4 py-2 text-right">اليوم</th>
                <th className="border border-gray-300 px-4 py-2 text-right">التاريخ</th>
                <th className="border border-gray-300 px-4 py-2 text-right">الإجراءات</th>
              </tr>
            </thead>
            <tbody>
  {items.map((item, index) => (
    <tr key={index} className="hover:bg-gray-100">
 {/* Meal Type Dropdown */}
 <td className="border border-gray-300 px-4 py-2 text-right">
  {editingIndex === index ? (
    <select
      value={editItem.meal_type_id || ""}
      onChange={(e) => setEditItem({ 
        ...editItem, 
        meal_type_id: parseInt(e.target.value, 10) 
      })}
      className="w-full px-2 py-1 border border-gray-300 rounded-lg"
    >
      <option value="">اختر نوع الوجبة</option>
      {mealTypes.map((type) => (
        <option key={type.id} value={type.id}>
          {type.name}
        </option>
      ))}
    </select>
  ) : (
    mealTypes.find((type) => type.id === item.meal_type_id)?.name || "غير محدد"
  )}
</td>


{/* Source Dropdown */}
<td className="border border-gray-300 px-4 py-2 text-right">
  {editingIndex === index ? (
    <select
      value={editItem.source_id || ""}
      onChange={(e) => setEditItem({ 
        ...editItem, 
        source_id: parseInt(e.target.value, 10) 
      })}
      className="w-full px-2 py-1 border border-gray-300 rounded-lg"
    >
      <option value="">اختر المصدر</option>
      {sources.map((source) => (
        <option key={source.id} value={source.id}>
          {source.name}
        </option>
      ))}
    </select>
  ) : (
    sources.find((type) => type.id === item.source_id)?.name || "غير محدد"
  )}
</td>

{/* Reason Dropdown */}
<td className="border border-gray-300 px-4 py-2 text-right">
  {editingIndex === index ? (
    <select
      value={editItem.reason_id || ""}
      onChange={(e) => setEditItem({ 
        ...editItem, 
        reason_id: parseInt(e.target.value, 10) 
      })}
      className="w-full px-2 py-1 border border-gray-300 rounded-lg"
    >
      <option value="">اختر السبب</option>
      {reasons.map((reason) => (
        <option key={reason.id} value={reason.id}>
          {reason.name}
        </option>
      ))}
    </select>
  ) : (
    reasons.find((type) => type.id === item.reason_id)?.name || "غير محدد"
  )}
</td>

{/* Food Type Dropdown */}
<td className="border border-gray-300 px-4 py-2 text-right">
  {editingIndex === index ? (
    <select
      value={editItem.food_type_id || ""}
      onChange={(e) => setEditItem({ 
        ...editItem, 
        food_type_id: parseInt(e.target.value, 10) 
      })}
      className="w-full px-2 py-1 border border-gray-300 rounded-lg"
    >
      <option value="">اختر نوع الغذاء</option>
      {foodTypes.map((food) => (
        <option key={food.id} value={food.id}>
          {food.name}
        </option>
      ))}
    </select>
  ) : (
    foodTypes.find((type) => type.id === item.food_type_id)?.name || "غير محدد"
  )}
</td>

{/* Food Description Input (Kept as input) */}
<td className="border border-gray-300 px-4 py-2 text-right">
  {editingIndex === index ? (
    <select
      value={editItem.food_description || ""}
      onChange={(e) => {
        const selectedDesc = foodTypes
          .find((food) => food.id === editItem.food_type_id)
          ?.food_descriptions?.find((desc) => desc.name === e.target.value);
        setEditItem({
          ...editItem,
          food_description: selectedDesc ? selectedDesc.name : "",
          food_description_id: selectedDesc ? selectedDesc.id : "",
        });
      }}
      className="w-full px-2 py-1 border border-gray-300 rounded-lg"
    >
      <option value="">اختر وصف الغذاء</option>
      {foodTypes
        .find((food) => food.id === editItem.food_type_id)
        ?.food_descriptions?.map((desc) => (
          <option key={desc.id} value={desc.name}>
            {desc.name}
          </option>
        ))}
    </select>
  ) : (
    item.food_description || "غير محدد"
  )}
</td>



      <td className="border border-gray-300 px-4 py-2 text-right">
  {editingIndex === index ? (
    <select
      value={editItem.is_edible ? "صالح" : "غير صالح"}
      onChange={(e) => setEditItem({ 
        ...editItem, 
        is_edible: e.target.value === "صالح" 
      })}
      className="w-full px-2 py-1 border border-gray-300 rounded-lg"
    >
      <option value="صالح">صالح</option>
      <option value="غير صالح">غير صالح</option>
    </select>
  ) : (
    item.is_edible ? "صالح" : "غير صالح"
  )}
</td>


      <td className="border border-gray-300 px-4 py-2 text-right">
        {editingIndex === index ? (
          <input
            type="number"
            value={editItem.empty_weight}
            onChange={(e) => setEditItem({ ...editItem, empty_weight: e.target.value })}
            className="w-full px-2 py-1 border border-gray-300 rounded-lg"
          />
        ) : (
          item.empty_weight
        )}
      </td>

      <td className="border border-gray-300 px-4 py-2 text-right">
        {editingIndex === index ? (
          <input
            type="number"
            value={editItem.total_weight}
            onChange={(e) => setEditItem({ ...editItem, total_weight: e.target.value })}
            className="w-full px-2 py-1 border border-gray-300 rounded-lg"
          />
        ) : (
          item.total_weight
        )}
      </td>

      <td className="border border-gray-300 px-4 py-2 text-right">
        {editingIndex === index ? (
          <input
            type="text"
            value={editItem.employee_name}
            onChange={(e) => setEditItem({ ...editItem, employee_name: e.target.value })}
            className="w-full px-2 py-1 border border-gray-300 rounded-lg"
          />
        ) : (
          item.employee_name
        )}
      </td>

      <td className="border border-gray-300 px-4 py-2 text-right">
  {editingIndex === index ? (
    <select
      value={editItem.shift}
      onChange={(e) => setEditItem({ ...editItem, shift: e.target.value })}
      className="w-full px-2 py-1 border border-gray-300 rounded-lg"
    >
      <option value="A">A</option>
      <option value="B">B</option>
      <option value="C">C</option>
    </select>
  ) : (
    item.shift
  )}
</td>


      <td className="border border-gray-300 px-4 py-2 text-right">
        {editingIndex === index ? (
          <input
            type="text"
            value={editItem.day}
            onChange={(e) => setEditItem({ ...editItem, day: e.target.value })}
            className="w-full px-2 py-1 border border-gray-300 rounded-lg"
          />
        ) : (
          item.day
        )}
      </td>

      <td className="border border-gray-300 px-4 py-2 text-right">
        {editingIndex === index ? (
          <input
            type="date"
            value={editItem.waste_date}
            onChange={(e) => setEditItem({ ...editItem, waste_date: e.target.value })}
            className="w-full px-2 py-1 border border-gray-300 rounded-lg"
          />
        ) : (
          item.waste_date
        )}
      </td>

      {/* Actions: Edit & Delete */}
      <td className="border border-gray-300 px-4 py-2 text-center">
        {editingIndex === index ? (
          <>
            <button
              onClick={saveEdit}
              className="bg-green-500 text-white py-1 px-3 rounded-lg hover:bg-green-600 mx-1"
            >
              حفظ
            </button>
            <button
              onClick={cancelEdit}
              className="bg-gray-500 text-white py-1 px-3 rounded-lg hover:bg-gray-600 mx-1"
            >
              إلغاء
            </button>
          </>
        ) : (
          <>
            <button
              onClick={() => startEditing(index)}
              className="p-2 rounded-lg hover:bg-blue-100 mx-1"
            >
              <img src={editIcon} alt="تعديل" className="w-5 h-5" />
            </button>
            <button
              onClick={() => confirmDelete(index)}
              className="p-2 rounded-lg hover:bg-red-100 mx-1"
            >
              <img src={deleteIcon} alt="حذف" className="w-5 h-5" />
            </button>
          </>
        )}
      </td>
    </tr>
  ))}
</tbody>


          </table>
        </div>
      )}

      {items.length > 0 && (
        <div className="mt-12 text-left">
          <button
            onClick={onSave}
            className="bg-[#DD5B35] text-white py-2 px-6 rounded-lg hover:bg-[#F4A68D] hover:text-black"
          >
            حفظ العناصر
          </button>
        </div>
      )}

{showSuccessPopup && (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div className="bg-white p-6 rounded-lg shadow-lg w-96">
      <h2 className="text-xl font-semibold text-gray-700 text-center mb-4">
        ✅ تم حفظ البيانات بنجاح!
      </h2>
      <div className="flex justify-center mt-4">
        <button
          onClick={() => setShowSuccessPopup(false)}
          className="bg-green-500 text-white py-2 px-6 rounded-lg hover:bg-green-600"
        >
          موافق
        </button>
      </div>
    </div>
  </div>
)}



      {/* Delete Confirmation Popup */}
      {deleteIndex !== null && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg w-96">
            <h2 className="text-xl font-semibold text-gray-700 text-center mb-4">
              هل أنت متأكد أنك تريد حذف هذا العنصر؟
            </h2>
            <div className="flex justify-around mt-4">
              <button
                onClick={deleteItem}
                className="bg-red-500 text-white py-2 px-6 rounded-lg hover:bg-red-600"
              >
                نعم
              </button>
              <button
                onClick={() => setDeleteIndex(null)}
                className="bg-gray-500 text-white py-2 px-6 rounded-lg hover:bg-gray-600"
              >
                إلغاء
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Table;
